/* Catchy Device Finder – core: device list, matching and the Brand/Model finder.
   Used by sections/catchy-category-bento.liquid and sections/catchy-device-page.liquid. */
(function () {
  'use strict';
  if (window.CatchyDeviceCore) { window.CatchyDeviceCore.boot(); return; }

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var STORE_KEY = 'cd:last';
  var SIZES = [9.7, 10.2, 10.5, 10.9, 11, 12.9, 13, 13.3, 13.6, 14, 14.2, 15, 15.3, 15.6, 16, 16.2];

  /* ------------------------------------------------------------ text helpers */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function slug(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function clean(s) {
    return String(s || '').toLowerCase()
      .replace(/[“”″"]/g, ' ')
      .replace(/\+/g, ' plus ')
      .replace(/\s*-\s*/g, '-')
      .replace(/[(),]/g, ' ')
      .replace(/(\d)([a-z]{2,})/g, '$1 $2') /* "S24Ultra" -> "S24 Ultra" */
      .replace(/\b(apple|samsung|galaxy)\b/g, ' ')
      .replace(/\binch(es)?\b/g, ' ')
      .replace(/\s+/g, ' ').trim();
  }
  function tokens(s) {
    return clean(s).split(' ').map(function (t) { return t.replace(/^-+|-+$/g, ''); }).filter(Boolean);
  }
  function key(s) { return tokens(s).sort().join(' '); }
  function sizesOf(s) {
    var out = [];
    tokens(s).forEach(function (t) {
      t.split('-').forEach(function (n) { var v = parseFloat(n); if (/^\d+(\.\d)?$/.test(n) && SIZES.indexOf(v) > -1 && out.indexOf(v) < 0) out.push(v); });
    });
    return out;
  }
  function onlyNumbers(s) { var t = tokens(s); return t.length > 0 && t.every(function (x) { return /^[\d.\-]+$/.test(x); }); }
  function splitVals(v) {
    var parts = String(v || '').split('/').map(function (p) { return p.trim(); }).filter(Boolean);
    var lead = parts.length > 1 && (parts[0].match(/^([A-Za-z]+)\s/) || [])[1];
    return parts.map(function (p, i) { return i && lead && /^\d/.test(p) ? lead + ' ' + p : p; });
  }
  function macInfo(s) {
    var c = clean(s), years = [], m, re = /(20\d\d)(?:-(20\d\d))?/g;
    while ((m = re.exec(c))) { var a = +m[1], b = +(m[2] || m[1]); for (var y = a; y <= b && y - a < 20; y++) years.push(y); }
    var size = sizesOf(s)[0];
    if (size) size = size === 15.3 ? 15 : Math.floor(size);
    return { line: /\bair\b/.test(c) ? 'air' : (/\bpro\b/.test(c) ? 'pro' : ''), size: size || 0, years: years };
  }

  /* ------------------------------------------------------------ device list */
  var DATA = null;
  function data() {
    if (DATA) return DATA;
    var el = document.getElementById('catchy-device-data'), brands = [], cur = null;
    String(el ? el.textContent : '').split(/\r?\n/).forEach(function (line) {
      line = line.trim();
      if (!line) return;
      if (line.charAt(0) === '#') {
        var name = line.replace(/^#+/, '').trim();
        cur = { id: slug(name), name: name, models: [], mac: /mac/i.test(name), sized: /ipad|tab/i.test(name) || /mac/i.test(name) };
        brands.push(cur);
        return;
      }
      if (!cur) return;
      var parts = line.split(/\s+=\s+/), label = parts[0].trim();
      var model = { label: label, id: slug(label), keys: {}, sizes: [], phrases: [] };
      parts.forEach(function (p) { model.keys[key(p)] = 1; model.phrases.push(tokens(p).join(' ')); sizesOf(p).forEach(function (z) { if (model.sizes.indexOf(z) < 0) model.sizes.push(z); }); });
      if (cur.mac) model.mac = macInfo(label);
      cur.models.push(model);
    });
    DATA = brands;
    return brands;
  }
  function findBrand(id) { var b = data(); for (var i = 0; i < b.length; i++) if (b[i].id === id || slug(b[i].name) === slug(id)) return b[i]; return null; }
  function findModel(brand, val) {
    if (!brand || !val) return null;
    var k = key(val), s = slug(val);
    for (var i = 0; i < brand.models.length; i++) { var m = brand.models[i]; if (m.id === s || m.label === val || m.keys[k]) return m; }
    return null;
  }
  function displayName(brand, model) {
    return /^(iphone|ipad|macbook|galaxy|samsung)/i.test(model.label) ? model.label : brand.name + ' ' + model.label;
  }

  /* ------------------------------------------------------------ does a product fit? */
  /* which device families a text names – "iPhone 14 Pro" must never count for "MacBook Pro 14" */
  var FAMS = { iphone: /\biphone/, samsung: /\b(samsung|galaxy)\b/, ipad: /\bipad/, macbook: /\b(macbook|laptop|notebook)\b/ };
  function famsOf(s) {
    s = String(s || '').toLowerCase();
    var out = [];
    for (var f in FAMS) if (FAMS[f].test(s)) out.push(f);
    return out;
  }
  function otherFamily(brand, s) { var f = famsOf(s); return f.length > 0 && f.indexOf(brand.id) < 0; }
  /* model numbers such as A2442 or "A2941(M2)" */
  function codesOf(s) { return (String(s || '').toLowerCase().match(/\ba\d{4}\b/g) || []); }
  function valueFits(brand, model, v, kind) {
    var parts = splitVals(v);
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i];
      if (otherFamily(brand, p)) continue;
      if (model.keys[key(p)]) return true;
      if (codesOf(p).some(function (c) { return model.keys[c]; })) return true;
      if (brand.mac) {
        if (!kind.laptop) continue; /* sizes like "14 inch" only count on laptop products */
        var x = macInfo(p), m = model.mac;
        if (x.size && m && x.size === m.size) {
          if (!x.line && !/[a-z]{3,}/.test(clean(p).replace(/\b(m\d|retina)\b/g, ''))) return true; /* size only, e.g. "14 inch" / "13.3" */
          if (x.line && x.line === m.line && (!x.years.length || x.years.some(function (y) { return m.years.indexOf(y) > -1; }))) return true;
        }
      } else if (brand.sized && kind.tablet && onlyNumbers(p)) {
        var zs = sizesOf(p);
        if (zs.some(function (z) { return model.sizes.indexOf(z) > -1; })) return true;
      }
    }
    return false;
  }
  /* model written in the product title, e.g. "Samsung S24 Ultra Camera Lens Protector" */
  var SUFFIX = /^(pro|max|plus|ultra|fe|edge|mini|lite|air|e|neo)$/;
  function titleFits(brand, model, title) {
    if (!title || brand.mac || brand.sized) return false;
    var words = tokens(title), s = ' ' + words.join(' ') + ' ';
    return model.phrases.some(function (ph) {
      var at = s.indexOf(' ' + ph + ' ');
      while (at > -1) {
        var after = s.slice(at + ph.length + 2).split(' ')[0];
        if (!SUFFIX.test(after)) return true; /* "S24" must not match "S24 Ultra" */
        at = s.indexOf(' ' + ph + ' ', at + 1);
      }
      return false;
    });
  }
  /* title/type = what the product is; colls = its collection handles (space separated) */
  function productFits(brand, model, vals, title, colls) {
    if (otherFamily(brand, title)) return false; /* an "iPhone case" never fits a Samsung, iPad or MacBook */
    var c = String(colls || '').toLowerCase(), t = String(title || '').toLowerCase();
    var kind = {
      laptop: /macbook|laptop|notebook/.test(t + ' ' + c),
      tablet: /ipad|tablet/.test(t + ' ' + c)
    };
    var list = (vals || '').split('|');
    for (var i = 0; i < list.length; i++) if (list[i] && valueFits(brand, model, list[i], kind)) return true;
    return titleFits(brand, model, title);
  }
  function isUsbC(brand, model) {
    var l = model.label;
    if (brand.id === 'iphone') { var n = parseInt((l.match(/iphone\s*(\d+)/i) || [])[1], 10); return /\bair\b|16e/i.test(l) || n >= 15; }
    if (brand.id === 'ipad') return !/ipad\s*(6|7|8|9)\b|air\s*3\b/i.test(l);
    return true;
  }

  /* ------------------------------------------------------------ remember last device */
  function saveLast(b, m) { try { localStorage.setItem(STORE_KEY, JSON.stringify({ b: b.id, m: m.label })); } catch (e) {} }
  function loadLast() { try { return JSON.parse(localStorage.getItem(STORE_KEY) || 'null'); } catch (e) { return null; } }

  /* ------------------------------------------------------------ finder form */
  function initFinder(form) {
    if (form.__cd) return; form.__cd = 1;
    var bSel = form.querySelector('[data-cd-brand]'), mSel = form.querySelector('[data-cd-model]');
    if (!bSel || !mSel) return;
    var brands = data();
    /* the device page shows the chosen device; everywhere else the fields start empty */
    var pre = form.getAttribute('data-current-brand') ? { b: form.getAttribute('data-current-brand'), m: form.getAttribute('data-current-model') } : null;
    bSel.innerHTML = '<option value="">' + esc(bSel.getAttribute('data-placeholder') || 'Select Device Type...') + '</option>' +
      brands.map(function (b) { return '<option value="' + esc(b.id) + '">' + esc(b.name) + '</option>'; }).join('');
    function mark() { bSel.classList.toggle('is-empty', !bSel.value); mSel.classList.toggle('is-empty', !mSel.value); }
    function fillModels(selected) {
      var b = findBrand(bSel.value);
      mSel.innerHTML = '<option value="">' + esc(mSel.getAttribute('data-placeholder') || 'Select Device') + '</option>' +
        (b ? b.models.map(function (m) { return '<option value="' + esc(m.label) + '"' + (m.label === selected ? ' selected' : '') + '>' + esc(m.label) + '</option>'; }).join('') : '');
      mark();
    }
    if (pre && findBrand(pre.b)) bSel.value = findBrand(pre.b).id;
    fillModels(pre && pre.m);
    bSel.addEventListener('change', function () { form.classList.remove('cd-need-model'); fillModels(''); if (bSel.value) mSel.focus(); });
    function go() {
      var b = findBrand(bSel.value), m = findModel(b, mSel.value);
      if (!m) { form.classList.add('cd-need-model'); (b ? mSel : bSel).focus(); return; }
      form.classList.add('cd-going');
      saveLast(b, m);
      var url = form.getAttribute('action') || (ROOT + 'pages/device');
      window.location.href = url + (url.indexOf('?') > -1 ? '&' : '?') + 'brand=' + encodeURIComponent(b.id) + '&model=' + encodeURIComponent(m.label);
    }
    /* choosing the model is enough – open the device page straight away */
    mSel.addEventListener('change', function () { form.classList.remove('cd-need-model'); mark(); if (mSel.value) go(); });
    form.addEventListener('submit', function (e) { e.preventDefault(); go(); });
  }

  /* ------------------------------------------------------------ chips scroller arrows */
  function initChips(wrap) {
    if (wrap.__cd) return; wrap.__cd = 1;
    var track = wrap.querySelector('[data-cd-chip-track]'), next = wrap.querySelector('[data-cd-chip-next]'), prev = wrap.querySelector('[data-cd-chip-prev]');
    if (!track) return;
    function upd() {
      if (prev) prev.hidden = track.scrollLeft <= 4;
      if (next) next.hidden = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    function go(d) { track.scrollBy({ left: d * track.clientWidth * 0.8, behavior: 'smooth' }); }
    if (next) next.addEventListener('click', function () { go(document.dir === 'rtl' ? -1 : 1); });
    if (prev) prev.addEventListener('click', function () { go(document.dir === 'rtl' ? 1 : -1); });
    track.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }

  function boot() {
    document.querySelectorAll('form[data-cd-finder]').forEach(function (f) { if (!f.closest('[data-cd-page]')) initFinder(f); });
    document.querySelectorAll('[data-cd-chips]').forEach(initChips);
    if (window.CatchyDevicePage) window.CatchyDevicePage.boot();
  }

  window.CatchyDeviceCore = { boot: boot, ROOT: ROOT, esc: esc, slug: slug, data: data, findBrand: findBrand, findModel: findModel, displayName: displayName,
    productFits: productFits, isUsbC: isUsbC, saveLast: saveLast, initFinder: initFinder, key: key, splitVals: splitVals };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();